const getters = {
  getLabelsList: state => state.labelsList
}

const actions = {
  setLabelsList ({ commit }, data) {
    commit('setLabelsList', data)
  }
}

const mutations = {
  setLabelsList (state, data) {
    state.labelsList = data
  }
}

const state = {
  labelsList: []
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
